import template from 'text!./templates/ho-select-changes.html';

export default [function () {
    return {
        template: template,
        'scope': {
            'model': '=',
            'mode': '=',
            'onNext': '='
        },
        'controller': ['$scope', function ($scope) {
            var VALID_FIELDS = ['valuables', 'mortgagee', 'coverages'];
            $scope.model = $scope.model || {};

            $scope.isValid = function () {
                return VALID_FIELDS.some(function (field) {
                    return $scope.model[field];
                });
            };

            $scope.next = function () {
                $scope.onNext({
                    'validFields': VALID_FIELDS
                });
            };

            $scope.getState = function () {
                if ($scope.mode !== 'full') {
                    return 'disabled';
                }
                return '';
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/ho/directives/HOSelectChanges.js
// module id = 1462
// module chunks = 0